// MessageCount.tsx
import { Badge, Text } from '@components'
import { api } from '@here/api'
import { useQuery } from '@tanstack/solid-query'
import { MessageSquare } from 'lucide-solid'
import { Show } from 'solid-js'
import { css } from 'styled-system/css'

async function fetchMessageCount(channelId: string): Promise<number> {
	const sb = api()
	const { count, error } = await sb
		.from('message')
		.select('id', { count: 'exact', head: true })
		.eq('channel_id', channelId)

	if (error) throw error
	return count ?? 0
}

export const MessageCount = (props: { channelId?: string }) => {
	const q = useQuery(() => ({
		queryKey: ['message-count', props.channelId],
		queryFn: () => fetchMessageCount(props.channelId!),
		enabled: !!props.channelId,
		staleTime: 30 * 60 * 1000, // 30m cache freshness
		gcTime: 30 * 60 * 1000, // 30m cache retention
		retry: 1,
		placeholderData: 0,
	}))

	return (
		<Badge
			size="sm"
			variant="solid"
			justifyContent="center"
			colorPalette="red"
			class={css({
				color: 'var(--colors-color-palette-light-2)',
				background: '#ff0000',
			})}
		>
			<MessageSquare color="var(--colors-color-palette-light-2)" />
			<Show
				when={!q.isLoading}
				fallback="…"
			>
				<Text size='sm'>{q.data ?? 0}</Text>
			</Show>
		</Badge>
	)
}
